import { IApplicationState } from '../../types/redux';
import { getPromos } from './getPromos';
import { getDiscounts } from './getDiscounts';

export function showSpecialPromos(state: IApplicationState) {
  const promos = getPromos(state);
  const discounts = getDiscounts(state);

  return Boolean(promos.length) || Boolean(discounts.length);
}
